import { connect } from 'react-redux'
import { createAuthStateToProps } from 'helpers/auth'
import selectors from 'selectors'
import locationGroupActions from 'actions/locationGroups'
import locationActions from 'actions/locations'
import jobActions from 'actions/jobs'
import operatorActions from 'actions/operators'
import Component from 'components/ReturnToInventory/Filter'

const mapStateToProps = (state, props) => ({
  ...createAuthStateToProps(state, props),
  locationGroups: selectors.locationGroups.selectOptions(state),
  locations: selectors.locations.selectOptions(state),
  jobs: selectors.jobs.selectOptions(state, { itemsOnly: false }),
  operators: selectors.operators.selectOptions(state, { itemsOnly: false }),
})

const mapDispatchToProps = (dispatch, props) => ({
  getLocationGroups: (params) => dispatch(locationGroupActions.getOptions(params)),
  getLocations: (params) =>
    dispatch(locationActions.getOptions({ ...params, active: 'All', locationVendingTypes: ['NonVending'] })),
  getJobs: (params) =>
    dispatch(
      jobActions.getOptions({
        pageIndex: 1,
        pageSize: 100,
        ...params,
        active: 'All',
      }),
    ),
  getOperators: (params) =>
    dispatch(
      operatorActions.getOptions({
        active: 'All',
        pageIndex: 1,
        pageSize: 100,
        ...params,
      }),
    ),
})

export default connect(mapStateToProps, mapDispatchToProps)(Component)
